import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=004d53dd&scoped=true"
var script = {}
import style0 from "./Spinner.vue?vue&type=style&index=0&id=004d53dd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004d53dd",
  null
  
)

export default component.exports